import { createSettingDocumentNameGenerator, deleteSettingDocumentNameGenerator, getSettingDocumentNameGenerators, patchSettingDocumentNameGenerator } from "../api/EnzianSettingsApi";
import { handleStoreError } from "./GeneralStore";
import { createSimpleListConfiguration, createSimpleListListFilter } from "../types/ListTypes";
import { _ } from "svelte-i18n";
import { get } from "svelte/store";
export function createSettingDocumentNameGeneratorStore() {
    let settingDocumentNameGeneratorStore = $state([]);
    let storeListeners = $state([]);
    let listFilter = $state(createSimpleListListFilter({
        localStorageKey: 'name-generator',
        filterOptions: [
            {
                label: get(_)('settings.basic.document_name_generators.lbl_name'),
                value: null,
                key: 'defaultName',
                type: 'string'
            },
            {
                label: get(_)('settings.basic.document_name_generators.lbl_pattern'),
                value: null,
                key: 'pattern',
                type: 'string'
            },
            {
                label: get(_)('settings.basic.document_name_generators.lbl_starting_number'),
                value: null,
                key: 'startingNumber',
                type: 'number'
            }
        ]
    }));
    let listConfig = $state(createSimpleListConfiguration({
        header: get(_)('settings.basic.document_name_generators.list_header'),
        cardModeConfig: {
            amountOfCols: 5
        }
    }));
    async function loadData() {
        try {
            const settingDocumentNameGenerators = await getSettingDocumentNameGenerators(listFilter);
            if (listFilter.page == 0) {
                //Reset the data.
                settingDocumentNameGeneratorStore = settingDocumentNameGenerators;
            }
            else {
                //Merge the lists
                settingDocumentNameGeneratorStore.push(...settingDocumentNameGenerators);
            }
            //Increase the page counter.
            if (settingDocumentNameGeneratorStore.length > 0) {
                listFilter.page += 1;
            }
        }
        catch (error) {
            handleStoreError('settings.basic.document_name_generators.err_load', error);
        }
    }
    return {
        set data(value) { settingDocumentNameGeneratorStore = value; },
        get data() {
            return settingDocumentNameGeneratorStore;
        },
        get listFilter() { return listFilter; },
        set listFilter(value) { listFilter = value; },
        get listConfig() { return listConfig; },
        set listConfig(value) { listConfig = value; },
        addNotifier(listener) {
            storeListeners.push(listener);
        },
        removeNotifier(listener) {
            storeListeners = storeListeners.filter((li) => li == listener);
        },
        loadData: loadData,
        async applyFilter() {
            //Reset the start id
            listFilter.page = 0;
            //Load the data.
            await loadData();
            //Inform the listeners
            storeListeners.forEach((listener) => {
                //Call the event
                listener.onFilterApplied();
            });
        },
        clear() {
            settingDocumentNameGeneratorStore = [];
        },
        async createSettingDocumentNameGeneratorStore(request) {
            const newValue = await createSettingDocumentNameGenerator(request);
            //Add the new item
            settingDocumentNameGeneratorStore.push(newValue);
        },
        async patchSettingDocumentNameGeneratorStore(settingDocumentNameGeneratorId, request) {
            const updatedValue = await patchSettingDocumentNameGenerator(settingDocumentNameGeneratorId, request);
            const index = settingDocumentNameGeneratorStore.findIndex(setting => setting.id == settingDocumentNameGeneratorId);
            if (index < 0)
                return;
            settingDocumentNameGeneratorStore[index] = updatedValue;
        },
        async deleteSettingDocumentNameGeneratorStore(settingDocumentNameGeneratorId) {
            await deleteSettingDocumentNameGenerator(settingDocumentNameGeneratorId);
            //Filter out the item
            settingDocumentNameGeneratorStore = settingDocumentNameGeneratorStore.filter(setting => setting.id != settingDocumentNameGeneratorId);
        }
    };
}
